import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getFluxoCaixaGraficos(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/fluxo_caixa/graficos/', {params});
  return data;
}

type QueryFnType = typeof getFluxoCaixaGraficos;

function useFluxoCaixaGraficos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-fluxo-caixa-graficos', params],
    queryFn: () =>  getFluxoCaixaGraficos(params),
  });
}

export { useFluxoCaixaGraficos };
